import { render, staticRenderFns } from "./UploadProductFilesButton.vue?vue&type=template&id=20fd9acf&scoped=true&"
import script from "./UploadProductFilesButton.vue?vue&type=script&lang=js&"
export * from "./UploadProductFilesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd9acf",
  null
  
)

export default component.exports